(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("ContactUsCtrl", ["publicResource", "messageService", "$scope", "$timeout", "userInfo", "REG_EXP", ContactUsCtrl]);
    function ContactUsCtrl(publicResource, messageService, $scope, $timeout, userInfo, REG_EXP) {
        var vm = this;
        vm.showErrors = false;
        vm.saving = false;
        vm.emailPattern = REG_EXP.email;
        vm.phonePattern = REG_EXP.phone;
        vm.methodOfContact = "Email";
        vm.firstName = userInfo.firstName;
        vm.lastName = userInfo.lastName;
        vm.email = userInfo.email;
        vm.tenantId = userInfo.tenantId;
        vm.regNumber = userInfo.regNumber;
        vm.submit = function (isValid) {
            vm.saving = true;
            if (isValid) {
                var model = {
                    tenantId: vm.tenantId,
                    firstName: vm.firstName,
                    lastName: vm.lastName,
                    email: vm.email,
                    phoneNumber: vm.phoneNumber,
                    comments: vm.comments,
                    preferredMethodOfContact: vm.methodOfContact,
                    registrationNumber: vm.regNumber
                };
                publicResource.contactUs(model, function () {
                    $scope.$close();
                    $timeout(function () {
                        messageService.success("public.contactUs.messageSent");
                    }, 500);
                }, function (error) {
                    vm.saving = false;
                    messageService.error(error);
                });
            }
            else {
                vm.showErrors = true;
                vm.saving = false;
            }
        };
    }
}());
